var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddpic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.5V3.995C8.5 3.995 7.505 4 7.5 3.995V2.5H6C6 2.5 6.005 1.505 6 1.5H7.5V0H8.5V1.5H10V2.5H8.5ZM7 4.5V3H5.5V1.5H1.5C0.95 1.5 0.5 1.95 0.5 2.5V8.5C0.5 9.05 0.95 9.5 1.5 9.5H7.5C8.05 9.5 8.5 9.05 8.5 8.5V4.5H7ZM1.5 8.5L3 6.5L4 8L5.5 6L7.5 8.5H1.5Z",
    fill: "#2A2E43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddpic);
export default __webpack_public_path__ + "static/media/addpic.80a4de539cd16ddfc03457e7bf386c51.svg";
export { ForwardRef as ReactComponent };